import { Injectable } from "@angular/core";
import { ThemePalette } from "@angular/material/core";
import { MatDialog } from "@angular/material/dialog";
import { Observable } from "rxjs";

import { ConfirmDialogComponent } from "@skills-app/shared/components/confirm-dialog/confirm-dialog.component";

@Injectable({ providedIn: "root" })
export class DialogService {
  constructor(private matDialog: MatDialog) {}

  confirm(options: ConfirmDialogOptions): Observable<boolean> {
    const dialogRef = this.matDialog.open(ConfirmDialogComponent, {
      width: "400px",
      data: { ...ConfirmDialogDefaultOptions, ...options },
    });

    return dialogRef.afterClosed();
  }
}

export const ConfirmDialogDefaultOptions: Partial<ConfirmDialogOptions> = {
  buttonLabels: ["Yes", "No"],
  buttonColors: ["primary", undefined],
};

export interface ConfirmDialogOptions {
  title: string;
  message: string;
  buttonLabels?: string[];
  buttonColors?: ThemePalette[];
}
